import { Component, OnInit, Input, ElementRef } from '@angular/core';

enum MenuItemClass {
  two = 2,
  three = 3,
  four = 4,
  five = 5,
}

@Component({
  selector: 'monorepo-menu-list-items',
  templateUrl: './menu-list-items.component.html',
  styleUrls: ['./menu-list-items.component.scss'],
})
export class MenuListItemsComponent implements OnInit {
  @Input() menuItem: any;
  @Input() themeColor: any;
  menuItemLength;

  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {
    this.menuItemLength = MenuItemClass[this.menuItem.length];
    this.setThemeClass(this.themeColor);
  }

  public setThemeClass(themeColor: any): void {
    this.elementRef.nativeElement.style.setProperty(
      '--primary',
      themeColor.primary
    );
    this.elementRef.nativeElement.style.setProperty(
      '--secondary',
      themeColor.secondary
    );
  }
}
